var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBulkTest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.09091 7.90909H8.72727M16.9091 12H15.2727M7.09091 16.0909H8.72727M12 7.90909H16.9091M12 12H7.09091M12 16.0909H16.9091M9.54545 21H14.4545C16.7457 21 17.8912 21 18.7663 20.5541C19.5361 20.1619 20.1619 19.5361 20.5541 18.7663C21 17.8912 21 16.7457 21 14.4545V9.54545C21 7.25433 21 6.10877 20.5541 5.23368C20.1619 4.46392 19.5361 3.83809 18.7663 3.44588C17.8912 3 16.7457 3 14.4545 3H9.54545C7.25433 3 6.10877 3 5.23368 3.44588C4.46392 3.83809 3.83809 4.46392 3.44588 5.23368C3 6.10877 3 7.25433 3 9.54545V14.4545C3 16.7457 3 17.8912 3.44588 18.7663C3.83809 19.5361 4.46392 20.1619 5.23368 20.5541C6.10877 21 7.25433 21 9.54545 21Z",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkTest);
export default __webpack_public_path__ + "static/media/bulk_test.71dbe4fefe5f84064e6cceaff8d54d0a.svg";
export { ForwardRef as ReactComponent };